import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./msalConfig";

export const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL instance
msalInstance.initialize().then(() => {
  // Handle redirect promise
  msalInstance.handleRedirectPromise().then((response) => {
    // Redirect authentication successful
  }).catch((error) => {
    console.error("Redirect authentication failed", error);
  });
}).catch((error) => {
  console.error("MSAL initialization failed", error);
});